<div class="social-auth-options flex flex-row items-center justify-center">
  <div class="flex flex-row gap-4">
    <ion-button (click)="doGoogleLogin()">
      <ion-icon class="google-login" src="../../assets/icon/google-logo.svg"></ion-icon>
    </ion-button>
  </div>
</div>
